import { render, staticRenderFns } from "./PaymentPurchaseWidget.vue?vue&type=template&id=c1249226&scoped=true"
import script from "./PaymentPurchaseWidget.vue?vue&type=script&lang=js"
export * from "./PaymentPurchaseWidget.vue?vue&type=script&lang=js"
import style0 from "./PaymentPurchaseWidget.vue?vue&type=style&index=0&id=c1249226&prod&lang=scss"
import style1 from "./PaymentPurchaseWidget.vue?vue&type=style&index=1&id=c1249226&prod&lang=scss&scoped=true"
import style2 from "./PaymentPurchaseWidget.vue?vue&type=style&index=2&id=c1249226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1249226",
  null
  
)

export default component.exports